import React, { Component } from "react";
import axios from "axios";
import { authService } from "../auth";
import Header from "../Header";
import LeftPanel from "../LeftPanel";
import * as _ from "lodash";
import AddCommentBox from "../commons/AddCommentBox";
import Comment from "../commons/Comment";
import { ReactTinyLink } from "react-tiny-link";
import Follow from "../commons/Follow";
import AudioPlayer from "react-h5-audio-player";
import httpService from "../AxiosInterceptors";
import ExploreBlogSharePreview from "./ExploreBlogSharePreview";
import ProjectSharePreview from "./ProjectSharePreview";
import ForumSharePreview from "./ForumSharePreview";
import PollSharePreview from "./PollSharePreview";
import PostSharePreview from "./PostSharePreview";
import StorySharePreview from "./StorySharePreview";
import ReportAbuse from "../commons/ReportAbuse";
import $, { event } from "jquery";
import {
  convertUnicode,
  get720pTranscodedVideo,
  getCDNUrl,
  isWebView,
  postMsg,
  nFormatter,
  pointCalculationUpdate,
  postNotFoundFunction,
  matchPostLinkUrl,
  isMobileDevice,
  userAgentGetData,
  adminFlagData,
  getOptimizedArticleImage,
  getEnviormentRegex,
  videoThumbnailFunction
} from "../commons/CommonFunctions";
import Images from "../commons/Images";
import "../commons/styles/fb-image-grid-style.min.css";
import "../forum/main-forum.min.css";
import Linkify from "react-linkify";
import { renderToString } from "react-dom/server";
import NotFound from "../404";
import ShareContentRemovedPreview from "./ShareContentRemovedPreview";
import BypassHeader from "../BypassHeader";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";
import SignUpModal from "../SignUpModal/signUpModal";
import Share from "../commons/Share";
import TimeAgo from "javascript-time-ago";
import Forbidden from "../Forbidden";
import { Link, NavLink, Redirect, withRouter } from "react-router-dom";
import EntityFollow from "../commons/EntityFollow";
import dateUtil from "date-and-time";

// English.
import en from "javascript-time-ago/locale/en";
import stripHtml from "string-strip-html";
import MentionTextArea from "../commons/MentionTextArea";
import cloneDeep from "lodash/cloneDeep";
import ReadMoreReadLess from "../commons/ReadMoreReadLess";
import LeftPanelUnauth from "../commons/LeftPanelUnauth";
import ReactPlayer from "react-player";
import Picker from "emoji-picker-react";
import AutoSuggest from "../AutoSuggest";
import mappingUtils from "../project/component/commons/utils/mappingUtils";
import uuid from "react-uuid";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ForbiddenUnAuth from "../ForbiddenUnAuth";
import HideInfoPage from "../static/HideInfoPage";
import { LazyLoadImage } from "react-lazy-load-image-component";
import UnauthPageItem from "../UnauthPageItem/UnauthPageItem";
import StudioSharePreview from "./StudioSharePreview";
import PrivateProjectHidePage from "../static/PrivateProjectHidePage";
import EditArticlePopUp from "../EditArticlePopUp";
import PresentationPostView from "./PresentationPostView";
import CommonAttachmentSection from "../commons/CommonAttachmentSection";
import PresentationSharePreview from "./PresentationSharePreview";
import SavePostButton from "./SavePostButton";
import UserReactionComponent from "../UserReaction/UserReactionComponent";
import CommonLinkPreview from "../commons/CommonLinkPreview";
import { Waypoint } from "react-waypoint";
import { pageClickHookPostMethod } from "../services/PostApi";
import CommonPostViews from "./CommonPostViews";

TimeAgo.addLocale(en);
httpService.setupInterceptors();
const timeAgo = new TimeAgo("en-US");
class PostDetail extends Component {
  constructor(props) {
    super(props);
    let validation = {
      postText: {},
    };
    this.state = {
      userData: authService.getUserDetailsFromLocalStorage(),
      loginSuccess: authService.isAuthenticated(),
      postData: {},
      error: null,
      userComment: "",
      like: true,
      comments: "",
      commentCount: "",
      hashTags: [],
      tags: [],
      unAuthPost: [],
      unAuthCircle: [],
      notFoundStatusCode: false,
      canNotUpdate: false,
      forbiddenStatusCode: "",
      validation,
      editedText: "",
      page: 0,
      size: 5,
      successMessage: "",
      commentSuccessMessage: "",
      smileDisplay: false,
      opportunities: [],
      projectDetail: {},
      isModalOpen: false,
      projectId: undefined,
      linkdata: "",
      articleData: {},
      editArticleFlag: false,
      og_data1:{},
      og_data2:{},
      og_data3:{},
      editLinkPopUpShow: false,
      documentTitle: "",
      attachmentType: "",
      userId: authService.isAuthenticated() && (this.props?.location?.state?.userId ? this.props?.location?.state?.userId : authService.getUserDetailsFromLocalStorage()?.userId),
      shouldPlay: true,
      showStatsFlag: false
    };
  }

  handleEnterViewport = () => {
    this.setState({
        shouldPlay: true,
    })
  };
  handleExitViewport = () => {
      this.setState({
          shouldPlay: false
      })
  };

  varifyLinkData = (text) => {
    var match =
      /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.exec(
        text
      );
    this.setState({
      linkdata: "",
    });
    if (match && match[0] && this.isValidUrl(match[0])) {
      this.setState({
        linkdata: match[0],
      },()=>{
        this.getLinkPreviewUrl(this.state.linkdata, "PREVIEWLINK2")
      });
    }
  };

  handleSmileDisplay = () => {
    this.setState({
      smileDisplay: this.state.smileDisplay ? false : true,
    });
  };

  onToggleEmojiWindow = () => {
    const { smileDisplay } = this.state;
    this.setState({ smileDisplay: !smileDisplay });
  };

  onEmojiClick = (event, emojiObject) => {
    let editedText = cloneDeep(this.state.editedText);
    editedText = editedText + " " + emojiObject.emoji;
    this.setState({
      editedText: editedText,
    });
  };

  getLinkPreviewUrl = (text, type) => {
      let data = {
          url : text
      }
      axios({
          method: 'POST',
          url : `${process.env.REACT_APP_userServiceURL}/recommend/ogscrapper`,
          data: data,
          withCredentials: true
      }).then((response)=>{
          if(response?.data?.status === 200){
              this.setState({
                  [type === "PREVIEWLINK1" ? "og_data1" : type === "PREVIEWLINK2" ? "og_data2" : "og_data3"]: response?.data?.data
              })
          }
      }).catch((error)=>{
          console.log("Error",error);
      })
  };

  componentDidMount() {
    if (this.state.postData && this.state.postData.userName) {
      document.title =
        this.state.postData.userName +
        " shared on WeNaturalists | Ecosystem for Nature Professionals";
    } else {
      document.title = "Explore a smart way to work for Nature | WeNaturalists";
    }

    if (!this.state.loginSuccess) {
      this.getUnAuthPostDetails();
    } else {
      this.getPostDetails();
    }
    $("#commntIco").on("click", function (event) {
      event.preventDefault();
      $("#commentbox textarea").focus();
    });
    window.$(".playbutt").bind("contextmenu", function (e) {
      return false;
    });
    setTimeout(() => {
      this.setState({ ...this.state });
    }, 1500);

    document.querySelector("#root").addEventListener("click", event => {
      // Get parent element and check if click happened outside parent only
      const parent = document.querySelector(".emoji-picker-react");
      const { smileDisplay } = this.state;
      if (smileDisplay && !parent.contains(event.target)) {
        this.onToggleEmojiWindow();
      }
    });

    this.handlePageClickHookPost();
  }

  handlePageClickHookPost = async () => {
    let postData = {
      entityId: this.props.match.params?.id,
      userId: this.state.loginSuccess ? this.state.userData?.userId : null,
      entityType: "POST"
    }
    
    await pageClickHookPostMethod(postData);
}

  handleTagsChange = (tags) => {
    let hashTagsList = [];
    if (tags && tags.length > 0) {
      tags &&
        tags.map(function (data) {
          data = data.replace(
            /[`~!@$%^&*()|+\=?;:'",.#<>\{\}\[\]\\\/\s]/gi,
            ""
          );
          if (data != "") {
            hashTagsList.push(data);
          }
        });
    }
    this.setState({ tags: hashTagsList });
  };

  onDelete(i) {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({ tags });
  }

  onAddition(tag) {
    const tags = [].concat(this.state.tags, tag);
    this.setState({ tags });
  }

  redirect(id) {
    window.location = "/post/" + id;
  }

  getUnAuthPostDetails = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_userServiceURL}/unauth/post/getById?id=${this.props.match.params.id}&admin=${adminFlagData() ? true : false}`,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res && res.status === "200 OK") {
          let utcSeconds = res.body.createTime;
          let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          d.setUTCSeconds(utcSeconds / 1000);
          let editedText = "";
          if (res.body && res.body.description) {
            editedText = res.body.description;
          }
          let photoListMap = [];
          let photoListOriginalMap = [];
          let editedUrl = null;
          if (
            res.body &&
            res.body.postType === "LINK" &&
            res.body.postLinkTypeUrl
          ) {
            editedUrl = res.body.postLinkTypeUrl;
          }
          res.body &&
            res.body.attachmentIds &&
            res.body.attachmentIds.map((attachment, index) => {
              photoListOriginalMap.push(getCDNUrl(attachment.attachmentUrl));
              if (
                (window.innerWidth > 1000 || (window.innerWidth > 600 && window.innerWidth <= 1000)) &&
                attachment.resizedImages &&
                attachment.resizedImages["1000x1000"] != null
              ) {
                photoListMap.push(
                  getCDNUrl(attachment.resizedImages["1000x1000"])
                );
              } else if (
                window.innerWidth > 320 && window.innerWidth <= 600 &&
                attachment.resizedImages &&
                attachment.resizedImages["800x800"] != null
              ) {
                photoListMap.push(getCDNUrl(attachment.resizedImages["800x800"]));
              } else {
                photoListMap.push(getCDNUrl(attachment.attachmentUrl));
              }
            });
          this.setState(
            {
              postData: res.body,
              utcTime: d,
              editedText: editedText,
              photoListMap: photoListMap,
              photoListOriginalMap: photoListOriginalMap,
              editedUrl: editedUrl,
            },
            () => {
              if(this.state.postData?.description) {
                this.varifyLinkData(this.state.postData?.description);
              }
              if(this.state.postData?.postLinkTypeUrl) {
                this.getLinkPreviewUrl(this.state.postData?.postLinkTypeUrl, "PREVIEWLINK1");
              }
              window.$(".playbutt").bind("contextmenu", function (e) {
                return false;
              });
            }
          );
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.data) {
          if (error.response && error.response.status === 403) {
            this.setState({
              forbiddenStatusCode: error.response.status,
            });
          } else if (error.response && (error.response.status === 404 || error.response.status === 410)) {
            this.setState({ notFoundStatusCode: true });
          }
        }
      });
  };

  getPostDetails = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_userServiceURL}/post/get?id=${this.props.match.params.id}&postRequestingUserId=${this.state.userId}&admin=false${userAgentGetData()}`,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.status === "200 OK") {
          let utcSeconds = res.body.createTime;
          let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          d.setUTCSeconds(utcSeconds / 1000);
          let editedText = "";
          if (res.body && res.body.description) {
            editedText = res.body.description;
            
          }
          let photoListMap = [];
          let photoListOriginalMap = [];
          let editedUrl = null;
          if (
            res.body &&
            res.body.postType === "LINK" &&
            res.body.postLinkTypeUrl
          ) {
            editedUrl = res.body.postLinkTypeUrl;
          }
          res.body &&
            res.body.attachmentIds &&
            res.body.attachmentIds.map((attachment, index) => {
              photoListOriginalMap.push(getCDNUrl(attachment.attachmentUrl));
              if (
                (window.innerWidth > 1000 || (window.innerWidth > 600 && window.innerWidth <= 1000)) &&
                attachment.resizedImages &&
                attachment.resizedImages["1000x1000"] != null
              ) {
                photoListMap.push(
                  getCDNUrl(attachment.resizedImages["1000x1000"])
                );
              } else if (
                window.innerWidth > 320 && window.innerWidth <= 600 &&
                attachment.resizedImages &&
                attachment.resizedImages["800x800"] != null
              ) {
                photoListMap.push(getCDNUrl(attachment.resizedImages["800x800"]));
              } else {
                photoListMap.push(getCDNUrl(attachment.attachmentUrl));
              }
            });
          this.setState(
            {
              postData: res.body,
              utcTime: d,
              editedText: editedText,
              photoListMap: photoListMap,
              photoListOriginalMap: photoListOriginalMap,
              editedUrl: editedUrl,
              successMessage: "Success!",
              documentTitle: res.body?.attachmentIds?.length > 0 ? res.body?.attachmentIds[0].title : "",
              attachmentType: res.body?.attachmentIds?.length > 0 ? res.body?.attachmentIds[0].attachmentType : ""
            },
            () => {
              this.setState(
                {
                  page: 0,
                },
                () => {
                  this.getAllComments(this.state.page, 5, false);
                  if(this.state.postData?.postLinkTypeUrl) {
                    this.getLinkPreviewUrl(this.state.postData?.postLinkTypeUrl, "PREVIEWLINK1");
                  }
                }
              );
              let tags = [];
              if (this.state.postData.hashTags) {
                this.setState({ hashTags: this.state.postData.hashTags });
              }
              this.state.postData &&
                this.state.postData.hashTags &&
                this.state.postData.hashTags.map((data, index) => {
                  tags.push(data);
                  this.setState({ tags: tags });
                });
                if(this.state.postData?.description) {
                  this.varifyLinkData(this.state.postData?.description);
                }
              window.$(".playbutt").bind("contextmenu", function (e) {
                return false;
              });
            },
          );
        }        
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          if (err.response && err.response.status === 403) {
            this.setState({
              forbiddenStatusCode: err.response.status,
            });
          }
          if (err.response && (err.response.status === 404 || err.response.status === 410)) {
            this.setState({ notFoundStatusCode: true });
          }
          this.setState({
            isLoaded: true,
            error: { message: err.response.data.message, err: err.response },
          });
        }
      });
  };

  fetchMoreCommentData = () => {
    this.setState({ isResultLoading: true, page: this.state.page + 1 }, () => {
      this.getAllComments(this.state.page, this.state.size, true);
    });
  };

  getAllComments = (page, size, concatWithPrevious) => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/comment/getCommentsByActivityId/" +
        this.state.postData.id +
        "?userId=" +
        this.state.userId +
        "&page=" +
        page +
        "&size=" +
        size,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.message === "Success!") {
          let pagedData = response.data.body;
          if (concatWithPrevious) {
            if (
              this.state.comments.content &&
              this.state.comments.content.length > 0
            ) {
              let comments = cloneDeep(this.state.comments.content);
              pagedData.content = comments.concat(pagedData.content);
            }
          }
          this.setState({
            comments: pagedData,
            pagination: response.data.body.last,
            commentCount:
              response.data.body.content.length > 0
                ? response.data.body.content[0].commentsCount
                : 0,
            commentSuccessMessage: response.data.message
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  redirectToArticleDetail(id) {
    var url = "/explore-detail/article/" + id;
    if (url !== undefined && url !== null) {
      if (window.ReactNativeWebView) {
        window.location.href = url;
      } else {
        window.open(
          url,
          "_blank",
          "toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=50,width=1000,height=1000"
        );
      }
    }
  }

  redirectToProfile = (customUrl) => {
    this.setState({ redirectToProfile: customUrl });
  };

  redirectToCircle = (customUrl) => {
    this.setState({ redirectToCircle: customUrl });
  };

  deletePost = () => {
    this.setState({ processingDeleteRequest: true });
    axios({
      method: "post",
      url:
        process.env.REACT_APP_userServiceURL +
        "/backend/post/delete/" +
        this.state.postData.id,
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.status === 202) {
          pointCalculationUpdate(this.state.userId);
          window
            .$("#" + this.state.postData.id + "confirmpopForDeletePost")
            .modal("hide");
          this.setState({ processingDeleteRequest: false });
          window.location = "/";
        } else {
          this.setState({ processingDeleteRequest: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ processingDeleteRequest: false });
      });
  };

  handlePostTextUpdate = (event) => {
    let value = event.target.value;
    this.setState({ editedText: value }, () => { });
  };

  openEditPost = (id, description) => {
    this.setState({
      editedText: description.replace(/(\r)/g, ""),
      documentTitle: this.state.documentTitle
    }, () => {
      window.$("#" + id + "toppostwrap").modal("show");
    })
  };

  openEditModal = (data) => {
      this.setState({
          articleData: data,
          editArticleFlag: true
      }, () => {
          window.$("#editArticlePopUp").modal("show");
      })
  }

  closeEditModal = () => {
      this.getPostDetails();
      this.setState({
          articleData: {},
          editArticleFlag: false
      })
  }

  openEditLinkPost = () => {
    this.setState({
      validUrlLinkPreview: this.state.postData.postLinkTypeUrl,
      editLinkPopUpShow: true
    },()=>{
      this.getLinkPreviewUrl(this.state.validUrlLinkPreview, "PREVIEWLINK3");
      window.$("#" + this.state.postData.id + "toppostwrapLink").modal("show");
    })
  };

  openDeleteModal = () => {
    window.$("#" + this.state.postData.id + "confirmpopForDeletePost").modal("show");
  };

  componentWillUnmount() {
    window.$("#" + this.state.postData.id + "confirmpopForDeletePost").modal("hide");
    window.$("#" + this.state.postData.id + "toppostwrap").modal("hide");
    window.$("#" + this.state.postData.id + "toppostwrapLink").modal("hide");
    window.$("#AcceptAudio").modal("hide");
  }

  hideUpdateModal = () => {
    this.setState({
      editedText: this.state.postData.description,
      editedUrl: this.state.postData.postLinkTypeUrl,
      canNotUpdate: false,
      editLinkPopUpShow: false
    });
    window.$("#" + this.state.postData.id + "toppostwrap").modal("hide");
    window.$("#" + this.state.postData.id + "toppostwrapLink").modal("hide");
  };

  triggerReportClose = () => {
    this.setState({ openReportModal: null });
  };

  handlePostUpdate = () => {
    if (this.validateForm()) {
      this.setState({ isPostUpdating: true });

      const formData = new FormData();
      formData.append("postId", this.state.postData.id);
      formData.append("description", this.state.editedText && this.state.editedText.replace(/(http(s))/g, " $1").trim("\n"));
      formData.append("attachmentTitle", this.state.documentTitle && this.state.documentTitle.replace(/\s+/g, ' ').trim());
      formData.append(
        "hashTags",
        this.state.tags
          ? this.state.tags.map((item) => {
            return item.replace(/#/g, "");
          })
          : []
      );
      if (this.state.validUrlLinkPreview) {
        formData.append("postLinkTypeUrl", this.state.validUrlLinkPreview);
      }
      axios({
        method: "post",
        url: process.env.REACT_APP_userServiceURL + "/backend/post/edit",
        data: formData,
        withCredentials: true,
      })
        .then((response) => {
          if (response && response.status === 202) {
            window.$("#" + this.state.postData.id + "toppostwrap").modal("hide");
            window.$("#" + this.state.postData.id + "toppostwrapLink").modal("hide");
            window.$("#AcceptAudio").modal("show");
            this.setState({ hashTags: this.state.tags });
            setTimeout(() => {
              window.$("#AcceptAudio").modal("hide");
            }, 60000);
            this.setState({
              isPostUpdating: false,
              postData: {
                ...this.state.postData,
                description: this.state.editedText.trim("\n"),
                postLinkTypeUrl: this.state.editedUrl,
              },
              documentTitle: this.state.documentTitle && this.state.documentTitle.replace(/\s+/g, ' ').trim(),
              smileDisplay: false,
              editLinkPopUpShow: false
            });
          } else {
            this.setState({
              isPostUpdating: false,
              smileDisplay: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isPostUpdating: false, smileDisplay: false });
          if (err.response.data.status === "404 NOT_FOUND") {
            postNotFoundFunction(this.state.postData.id);
          }
        });
    }
    setTimeout(() => {
      this.setState({
        error: "",
        errors: {},
      });
    }, 5000);
  };

  getCost = (project) => {
    let fees = "";
    if (
      (project && project.cost) ||
      project.remuneration ||
      project.renumeration
    ) {
      fees = project.cost || project.remuneration || project.renumeration;
    }
    return fees;
  };

  openOriginalPost(data) {
    if ((data.parentEntityType === "CIRCLE") && data.parentEntitySlug/*  || (!_.isEmpty(data.params) && data.params.userType?.toLowerCase() === "circle") */) {
      let slug = data.parentEntitySlug/*  || data.params?.circleSlug */;
      if (data.activityTabShow) {
        window.location.href = "/community/activity/" + slug;
      } else {
        window.location.href = "/community/" + slug;
      }
    } else if (
      (data.parentEntityType === "ASSIGNMENT" ||
        data.parentEntityType === "JOB" ||
        data.parentEntityType === "TRAINING" ||
        data.parentEntityType === "EVENT" ||
        data.parentEntityType === "EXPEDITION" ||
        data.parentEntityType === "STORYBOOK" ||
        data.parentEntityType === "FUNDRAISE") &&
      data.feedPageShowForProject &&
      data.parentEntitySlug
    ) {
      this.props.history.push({ pathname: `/project/feeds/${data.parentEntitySlug}`, state: { showActivyTab: true }})
    } else if (data.parentEntitySlug) {
      window.location.href = "/cause/" + data.parentEntitySlug;
    } else if (data.sharedEntityType) {
      switch (data.sharedEntityType) {
        case "POST":
          window.location.href = "/post/" + data.sharedEntityId;
          break;
        case "STORY":
          window.location.href = "/explore/";
          break;
        case "FORUM":
          window.location.href = "/forumDetail/" + data.sharedEntitySlug;
          break;
        case "POLL":
          window.location.href = "/pollDetail/" + data.sharedEntitySlug;
          break;
        case "EXPLOREBLOG":
          window.location.href = "explore-detail/blog/" + data.sharedEntitySlug;
          break;
        case "EVENT":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "STORYBOOK":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "FUNDRAISE":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "EXPEDITION":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "TRAINING":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "ASSIGNMENT":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "JOB":
          if (data.feedPageShowForProject && data.sharedEntitySlug) {
            this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
          }
          break;
        case "STUDIO":
          window.location.href = "/studio/" + data?.sharedEntityParams?.slug
        default:
          break;
      }
    } else if (data.feedPageShowForProject && data.sharedEntitySlug) {
      this.props.history.push({ pathname: `/project/feeds/${data.sharedEntitySlug}`, state: { showActivyTab: true }})
    } else if (data.parentEntityType === "CIRCLE") {
      if (data.activityTabShow) {
        window.location.href = "/community/activity/" + data.sharedEntitySlug;
      } else {
        window.location.href = "/community/" + data.sharedEntitySlug;
      }
    } else if (
      !data.sharedEntityType &&
      data.sharedEntitySlug &&
      data.parentEntityId
    ) {
      window.location.href = "/cause/" + data.sharedEntitySlug;
    } else if (!data.sharedEntityType && !data.sharedEntitySlug) {
      if (this.state.postData.userType !== "COMPANY") {
        if (data.activityTabShow) {
          window.location.href = "/profile-activity/" + data.userCustomUrl;
        } else {
          window.location.href = "/profile/" + data.userCustomUrl;
        }
      } else {
        if (data.activityTabShow) {
          if (data.userId === this.state.userData.userId) {
            window.location.href =
              "/organization-activity/" + data.userCustomUrl;
          } else {
            window.location.href =
              "/organization-other-activity/" + data.userCustomUrl;
          }
        } else {
          window.location.href = "/profile/" + data.userCustomUrl;
        }
      }
    }
  }

  validateForm = () => {
    this.state.validation.postText = {};
    let errors = {};
    let formIsValid = true;
    var regex = /\s+/gi;
    if (
      stripHtml(this.state.editedText).trim().replace(regex, " ").split(" ")
        .length > 400
    ) {
      errors["postText"] = "Please enter upto 400 words";
      this.state.validation.postText = {
        error: true,
        message: "Please enter upto 400 words",
        style: { borderColor: "#b34c4c", padding: "10px" },
      };
      formIsValid = false;
    }
    if (
      (!this.state.editedText.trim() || this.state.editedText.trim() === "") &&
      (!this.state.tags || this.state.tags.length === 0) &&
      this.state.postData.sharedEntityId === null &&
      this.state.postData.postType !== "LINK" &&
      this.state.photoListMap &&
      this.state.photoListMap.length === 0
    ) {
      errors["postText"] = "Please Post something to publish";
      this.state.validation.postText = {
        error: true,
        message: "Please Post something to publish",
        style: { borderColor: "#b34c4c", padding: "10px" },
      };
      formIsValid = false;
    }
    if((this.state.attachmentType === "PPT" || this.state.attachmentType === "PDF") && !this.state.documentTitle) {
      errors["documentTitle"] = "Please add document title";
      formIsValid = false;
    }
    if ((this.state.attachmentType === "PPT" || this.state.attachmentType === "PDF") && this.state.documentTitle && (this.state.documentTitle).replace(/\s/g, "").length > 60) {
        errors["documentTitle"] = "Document title should not be greater than 60 characters";
        formIsValid = false;
    }
    this.setState(
      {
        errors: errors,
      },
      () => {
        setTimeout(() => {
          this.setState({
            error: "",
            errors: {},
          });
        }, 5000);
      }
    );
    return formIsValid;
  };

  handleUrlUpdate = (event) => {
    this.setState({
      validUrlLinkPreview: "",
      editedUrl: event.target.value,
      canNotUpdate: true,
    });
    let value = event.target.value;
    if (this.isValidUrl(value)) {
      let data = matchPostLinkUrl(value);
      setTimeout(
        (value) => {
          this.setState({
            validUrlLinkPreview: data,
            canNotUpdate: false,
          },()=>{
            this.getLinkPreviewUrl(this.state.validUrlLinkPreview, "PREVIEWLINK3")
          });
        },
        2000,
        value
      );
    }
  };

  isValidUrl = (str) => {
    let regexp =
      /^(https?|ftp):\/\/(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(str);
  };

  handleLogin() {
    this.setState({ loginRequired: true });
    window.$("#loginModal").modal("show");
  }

  handleLoginClose = () => {
    this.setState({ loginRequired: false });
    window.$("#loginModal").modal("hide");
  };

  signUpRequired = () => {
    this.setState({ signUpRequired: true });
    window.$("#signupModal").modal("show");
  };

  handleSignUpClose = () => {
    this.setState({ signUpRequired: false });
    window.$("#signupModal").modal("hide");
  };

  loginRequired = (slug) => {
    this.setState({ loginRequired: true, pathname: slug });
    window.$("#loginModal").modal("show");
  };

  matchHashTags = (text) => {
    if (!text || text.length === 0) {
      return text;
    }
    var string = text;
    var regex = /(#[a-z\d-_]+)/gi;
    var matches = string.matchAll(regex);
    for (var match of matches) {
      if (match && match.length > 1) {
        string = string.replace(
          match[0],
          '<span class="hposthashitem" ' +
          'style="font-family: Montserrat,sans-serif;font-weight: 500;font-size: 12px;line-height: 15px;color: #bfc52e;">' +
          '<a href="/explore-hashtag/"' +
          match[0].substr(1) +
          '><i class="iHashtag"></i>' +
          match[0].substr(1) +
          "</span>"
        );
      }
    }
    return string;
  };

  renderTaggedUsers = (text) => {
    if (!text || text.length === 0) {
      return text;
    }

    text = text.split("@@@__").join('<a href="/profile/');
    text = text.split("^^__").join('">');
    text = text.split("&&__").join('">');
    text = text.split("&amp;&amp;__").join('">');
    text = text.split("&amp;&amp;__").join('">');
    text = text.split("@@@^^^").join("</a>");
    text = text
      .split("###__")
      .join(
        '<a class="hashLinkPost" style="cursor:pointer" href="/explore-hashtag/'
      );
    text = text
      .split("&&__")
      .join(
        '<a class="hashLinkPost" style="cursor:pointer" href="/explore-hashtag/'
      );
    text = text.split("###^^^").join("</a>");
    return text;
  };

  handleHideModal = (id) => {
    let data = {
      userId: this.state.userId,
      activityId: id,
      entityType: "POST",
    };

    axios({
      method: "post",
      url: process.env.REACT_APP_userServiceURL + "/hidden/hide",
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.status === 201) {
          window.location.href = "/";
        } else {
          this.setState({ isSubmitted: false });
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 409) {
          this.setState({
            error: "Entity has already been hidden",
            isSubmitted: false,
          });
        } else {
          this.setState({ isSubmitted: false });
        }
      });
  };

  refreshAllData = () => {
    window.location.href = "/";
  };

  refresh_comment = () => {
    this.setState(
      {
        page: 0,
        size: 5,
      },
      () => {
        this.getAllComments(this.state.page, 5, false);
      }
    );
  };

  getOptimizedImage = (personalInfo, defaultImg) => {
    if (
      personalInfo.resizedProfileImages &&
      personalInfo.resizedProfileImages["200x200"] != null
    ) {
      return personalInfo.resizedProfileImages["200x200"];
    }
    return defaultImg;
  };

  onHandleChange = (event) => {
    this.setState({
      documentTitle: event.target.value.trimStart()
    })
  }

  linkDataSection = (linkData, fetchData, regexSite) => {
    return (
      <div className="linkpostpreview">
          <div className="prevtitle">
            Preview
          </div>
          <div className="postarticledesc">
            {linkData.indexOf(
              "https://youtu.be"
            ) !== -1 ||
              linkData.indexOf(
                "www.youtube.com/watch"
              ) !== -1 ? (
              <>
                <div className="vidPlayerOverWrap">
                  <Waypoint onEnter={() => this.handleEnterViewport()} onLeave={() => this.handleExitViewport()} scrollableAncestor='window'>
                    <div>
                      <ReactPlayer
                        url={linkData}
                        width={"100%"}
                        playing={this.state.shouldPlay}
                        controls={true}
                        muted={true}
                      />
                    </div>
                  </Waypoint>
                </div>
                <div className="customLinkPost" onClick={()=>{ window.open(linkData, "_blank")}}>
                    <div className="customLinkPostDesc">
                      <h5>{fetchData?.title}</h5>
                      <p>{fetchData?.description}</p>
                      {/* <p>{linkData}</p> */}
                    </div>
                </div>
                <a
                  href={linkData}
                  className="btn playYoutube"
                  target="_blank"
                >
                  <i className="iYouTube_Logo" />{" "}
                  Play on Youtube
                </a>
              </>
            ) : (!_.isEmpty(fetchData) &&  
              <CommonLinkPreview linkdata={linkData} og_data={fetchData} />
            )}
          </div>
        </div>
    )
  }

  showStatsFunction = () => {
    this.setState({showStatsFlag: true},() =>{
      window.$('.forumdescmain .postVStats').click(function (event) {
        window.$(".potViewGlobal").collapse('toggle');
      });
    })
  }

  render() {
    const utcSeconds = this.state.postData && this.state.postData.createTime;
    let regexSite = getEnviormentRegex();
    const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds / 1000);
    let linkfiedHtml =
      '<p class="pdtlsLink">' +
      this.renderTaggedUsers(
        this.matchHashTags(
          renderToString(
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              )}
            >
              {this.state.postData.description
                ? this.state.postData.description
                : ""}
            </Linkify>
          )
        )
      )
        .replace(/&nbsp;/g, " ")
        .replace(/(\r\n|\r|\n)/g, "<br>")
        .replace(/(\\n)/g, "<br>") +
      "</p>";

    if (this.state.forbiddenStatusCode === 403 && this.state.loginSuccess) {
      return <Forbidden />;
    } else if (!this.state.loginSuccess) {
      if (this.state.forbiddenStatusCode === 403) {
        return (
          <>
            <ForbiddenUnAuth />
          </>
        );
      } else {
        return (
          <>
            <div
              className={"wrapper projectpage forumpage nologinpage" + ((this.state.notFoundStatusCode || this.state.postData.activityTabPrivate) && !adminFlagData() ? " staticPage p404" : "")}
            >
              {this.state.redirectToProfile && (
                <Redirect push to={"/profile/" + this.state.redirectToProfile} />
              )}
              {this.state.redirectToCircle && (
                <Redirect push to={"/community/" + this.state.redirectToCircle} />
              )}
              <BypassHeader
                notFound={
                  this.state.notFoundStatusCode || this.state.postData.activityTabPrivate ||
                    this.state.postData.hidden
                    ? true
                    : false
                }
                display={this.state.notFoundStatusCode || this.state.postData.activityTabPrivate ? true : false}
              />
              <main className="dgcontainer hm3col">
                <div className="container">
                  {this.state.notFoundStatusCode ? (
                    <HideInfoPage deletePost={true} />
                  ) : this.state.postData && (this.state.postData.activityTabPrivate || this.state.postData.hidden) && !adminFlagData() ? <PrivateProjectHidePage myStudioPage={true} /> : (
                    <div className="row">
                      <LeftPanelUnauth signUpRequired={this.signUpRequired} />
                      <div className="col-md-9">
                        <div className="projectinn">
                          <div className="forumdesctop">
                            <div className="forumdesctophead">
                              <div className="fdtheadleft">
                                {this.state.postData.userId &&
                                  !this.state.postData.userEntityType ? (
                                   <div className="fuserfollow post">
                                    <figure
                                      className="userlogo"
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.redirectToProfile(
                                          this.state.postData.userCustomUrl
                                        );
                                      }}
                                    >
                                      <img
                                        src={
                                          this.state.postData.userProfileImage !=
                                            null
                                            ? getCDNUrl(
                                              this.state.postData
                                                .userProfileImage
                                            )
                                            : this.state.postData.userType !==
                                              "COMPANY"
                                              ? "https://cdn.dscovr.com/images/users1.png"
                                              : "https://cdn.dscovr.com/images/DefaultBusiness.png"
                                        }
                                        alt=""
                                      />
                                    </figure>
                                    <div>
                                      <h3
                                        className= {"userName" + (this.state.postData?.userType === "COMPANY" ? " orgnzName" : "")}
                                        style={{
                                          marginRight: "5px",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.redirectToProfile(
                                            this.state.postData.userCustomUrl
                                          );
                                        }}
                                      >
                                        {this.state.postData.userName}
                                      </h3>
                                      {this.state.postData && this.state.postData.persona &&
                                      <div className="hpostPersona">{this.state.postData.persona}</div>}
                                      {this.state.postData.createdBy}
                                      <div className="pdUserAddrss hpostdtls">
                                        {this.state.postData &&
                                          this.state.postData.country && (
                                            <span className="address">
                                              <i className="iLocation" />
                                              {this.state.postData &&
                                                this.state.postData.country}
                                            </span>
                                          )}
                                        <span style={{ color: "#333333" }}>
                                          {this.state.utcTime &&
                                            timeAgo.format(
                                              this.state.utcTime,
                                              "mini-now"
                                            )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : this.state.postData.userEntityType &&
                                  this.state.postData.params ? (
                                  <div className="fuserfollow post">
                                    <figure
                                      className="userlogo"
                                      onClick={(e) => {e.preventDefault(); this.redirectToCircle(this.state.postData.params && this.state.postData.params["circleSlug"]);}}
                                      //onClick={this.handleLogin.bind(this)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src={
                                          this.state.postData.params &&
                                            this.state.postData.params[
                                            "circleImage"
                                            ] != null
                                            ? getCDNUrl(
                                              this.state.postData.params &&
                                              this.state.postData.params[
                                              "circleImage"
                                              ]
                                            )
                                            : "https://cdn.dscovr.com/images/circleDefault.webp"
                                        }
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "https://cdn.dscovr.com/images/circleDefault.png";
                                        }}
                                        alt=""
                                      />
                                    </figure>
                                    <div>
                                      <h3
                                        style={{
                                          marginRight: "5px",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {e.preventDefault(); this.redirectToCircle(this.state.postData.params && this.state.postData.params["circleSlug"]);}}
                                        //onClick={this.handleLogin.bind(this)}
                                      >
                                        {this.state.postData.params &&
                                          this.state.postData.params[
                                          "circleTitle"
                                          ]}
                                      </h3>
                                      {this.state.postData && this.state.postData.persona &&
                                      <div className="hpostPersona">{this.state.postData.persona}</div>}
                                      {this.state.postData.createdBy}
                                      <div className="pdUserAddrss hpostdtls">
                                        {this.state.postData &&
                                          this.state.postData.country && (
                                            <span className="address">
                                              <i className="iLocation" />
                                              {this.state.postData &&
                                                this.state.postData.country}
                                            </span>
                                          )}
                                        <span style={{ color: "#333333" }}>
                                          {this.state.utcTime &&
                                            timeAgo.format(
                                              this.state.utcTime,
                                              "mini-now"
                                            )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              {/* <div className="fdtheadright">
                                <div className="fdtheadrightbott">
                                  <div className="forumrowbright">
                                    <div className="likesblk">
                                      <a
                                        href="javascript:void(0)"
                                        onClick={this.handleLogin.bind(this)}
                                        className={"like"}
                                      />
                                      <a
                                        href="javascript:void(0)"
                                        onClick={this.handleLogin.bind(this)}
                                      >
                                        {this.state.postData &&
                                          this.state.postData.likesCount}
                                        &nbsp;
                                        <span>
                                          {this.state.postData &&
                                            this.state.postData.likesCount <= 1
                                            ? "Like"
                                            : "Likes"}
                                        </span>
                                      </a>
                                    </div>
                                    <a
                                      href="javascript:void(0)"
                                      className="comments"
                                      id="commntIco"
                                      onClick={this.handleLogin.bind(this)}
                                    >
                                      <span>
                                        {this.state.postData &&
                                          this.state.postData.commentCount}
                                        &nbsp;
                                        <span>
                                          {this.state.postData &&
                                            this.state.postData.commentCount <= 1
                                            ? "Comment"
                                            : "Comments"}
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                          <div className="forumdescmain">
                            {this.state.postData.postType === "ARTICLE" ? (
                              <div className="postarticleblock">
                                <div className="postarticleimg">
                                  {this.state.postData.attachmentIds &&
                                    this.state.postData.attachmentIds[0] &&
                                    this.state.postData.attachmentIds[0]
                                      .attachmentUrl ? (
                                    <img
                                      // src={
                                      //   this.state.postData.attachmentIds[0]
                                      //     .attachmentUrl
                                      // }
                                      src={getCDNUrl(getOptimizedArticleImage(this.state.postData.attachmentIds[0]))}
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src="https://cdn.dscovr.com/images/banner-explore-blog-small.webp"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "https://cdn.dscovr.com/images/banner-explore-blog-small-new.png";
                                      }}
                                      alt=""
                                    />
                                  )}
                                </div>
                                <div className="postarticledesc">
                                  {/*<div className="pacategory">Animals</div>*/}
                                  <div className="paauthor">
                                    {this.state.postData.userName}
                                  </div>
                                  <h2 className="articlePostTitle">{this.state.postData.title}</h2>
                                  <div
                                    className="padesctxt"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        this.state.postData &&
                                          this.state.postData.description
                                          ? this.state.postData.description
                                            .replace(/&nbsp;/g, " ")
                                            .replace(/(\r\n|\r|\n)/g, "<br>")
                                            .replace(/(\\n)/g, "<br>")
                                          : "",
                                    }}
                                  />
                                  <div className="text-center">
                                    <a
                                      href="javascript:void(0)"
                                      onClick={() =>
                                        window.open(
                                          "/explore-detail/article/" + this.state.postData.slug,
                                          "_blank",
                                          "toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=50,width=1000,height=1000"
                                        )
                                      }
                                      className="more btn"
                                    >
                                      read more
                                    </a>
                                  </div>
                                </div>
                              </div>
                            ) : this.state.postData.attachmentIds &&
                              this.state.postData.attachmentIds.length > 0 ? (
                              this.state.postData.attachmentIds[0]
                                .attachmentType === "VIDEO" ? (
                                <div>
                                  <div className="hpostconttop">
                                    {((this.state.postData &&
                                      this.state.postData.description &&
                                      this.state.postData.description !== "") ||
                                      this.state.postData.hashTags) && (
                                        <ReadMoreReadLess
                                          id={this.state.postData.id}
                                          description={
                                            this.state.postData.description
                                          }
                                          hashTags={this.state.postData.hashTags}
                                        />
                                      )}
  
                                    <figure className="hpostimggrid">
                                      <div className="himggrid vidbox">
                                        <a
                                          data-fancybox={uuid()}
                                          href={getCDNUrl(
                                            get720pTranscodedVideo(
                                              this.state.postData.attachmentIds[0]
                                            )
                                          )}
                                          onClick={() => this.handlePageClickHookPost()}
                                        >
                                          {((this.state.postData?.thumbnail) || (this.state.postData.attachmentIds[0].thumbnails &&  this.state.postData.attachmentIds[0].thumbnails[0])) ? (
                                          <img
                                            src={getCDNUrl(videoThumbnailFunction(this.state.postData))}
                                            alt=""
                                          />
                                        )
                                           : (
                                            <img
                                              src="https://cdn.dscovr.com/images/video-blank2.webp"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "https://cdn.dscovr.com/images/video-blank2.png";
                                              }}
                                              alt=""
                                            />
                                          )}
                                          <span className="playbutt"><i className="iPlay" /></span>
                                        </a>
                                      </div>
                                    </figure>
                                  </div>
                                </div>
                              ) : this.state.postData.attachmentIds[0]
                                .attachmentType === "AUDIO" ? (
                                <div>
                                  <div className="hpostconttop">
                                    {((this.state.postData &&
                                      this.state.postData.description &&
                                      this.state.postData.description !== "") ||
                                      this.state.postData.hashTags) && (
                                        <ReadMoreReadLess
                                          id={this.state.postData.id}
                                          description={
                                            this.state.postData.description
                                          }
                                          hashTags={this.state.postData.hashTags}
                                        />
                                      )}
  
                                    <AudioPlayer
                                      showJumpControls={false}
                                      customVolumeControls={[]}
                                      customAdditionalControls={[]}
                                      showDownloadProgress={false}
                                      src={getCDNUrl(
                                        this.state.postData.attachmentIds[0]
                                          .attachmentUrl
                                      )}
                                    />
                                  </div>
                                </div>
                              ) : (this.state.postData.attachmentIds[0].attachmentType === "PPT" || this.state.postData.attachmentIds[0].attachmentType === "PDF") ? (
                                <div>
                                  <div className="hpostconttop">
                                    {((this.state.postData &&
                                      this.state.postData.description &&
                                      this.state.postData.description !== "") ||
                                      this.state.postData.hashTags) && (
                                        <ReadMoreReadLess
                                          id={this.state.postData.id}
                                          description={
                                            this.state.postData.description
                                          }
                                          hashTags={this.state.postData.hashTags}
                                        />
                                      )}
                                      <PresentationPostView attachments={this.state.postData.attachmentIds[0]} />
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <div className="hpostconttop">
                                    {((this.state.postData &&
                                      this.state.postData.description &&
                                      this.state.postData.description !== "") ||
                                      this.state.postData.hashTags) && (
                                        <ReadMoreReadLess
                                          id={this.state.postData.id}
                                          description={
                                            this.state.postData.description
                                          }
                                          hashTags={this.state.postData.hashTags}
                                        />
                                      )}
  
                                    {this.state.photoListMap &&
                                      this.state.photoListMap.length > 0 && (
                                        <Images
                                          images={this.state.photoListMap}
                                          countFrom={5}
                                          photoListOriginalMap={
                                            this.state.photoListOriginalMap
                                          }
                                          entityId={this.state.postData?.id}
                                        />
                                      )}
                                  </div>
                                </div>
                              )
                            ) : this.state.postData.postType === "LINK" ? (
                              this.state.postData.postLinkTypeUrl &&
                              this.isValidUrl(this.state.postData.postLinkTypeUrl) && (
                                <>
                                  <div className="hpostconttop">
                                    {((this.state.postData &&
                                      this.state.postData.description &&
                                      this.state.postData.description !== "") ||
                                      this.state.postData.hashTags) && (
                                        <ReadMoreReadLess
                                          id={this.state.postData.id}
                                          description={
                                            this.state.postData.description
                                          }
                                          hashTags={this.state.postData.hashTags}
                                        />
                                      )}
  
                                    {this.state.postData && this.state.postData.postLinkTypeUrl && !this.state.editLinkPopUpShow &&
                                      this.isValidUrl(this.state.postData.postLinkTypeUrl) && (
                                        this.linkDataSection(this.state.postData.postLinkTypeUrl, this.state.og_data1, regexSite)
                                      )}
                                  </div>
                                </>
                              )
                            ) : this.state.postData.sharedEntityId &&
                              this.state.postData.sharedEntityId !== "" ? (
                              <>
                                <div className="hpostconttop">
                                  {((this.state.postData &&
                                    this.state.postData.description &&
                                    this.state.postData.description !== "") ||
                                    this.state.postData.hashTags) && (
                                      <ReadMoreReadLess
                                        id={this.state.postData.id}
                                        description={
                                          this.state.postData.description
                                        }
                                        hashTags={this.state.postData.hashTags}
                                      />
                                    )}
                                  {/* {this.state.linkdata && (
                                    this.linkDataSection(this.state.linkdata, this.state.og_data2, regexSite)
                                  )} */}
                                  {this.state.postData.sharedEntityParams &&
                                    Object.keys(
                                      this.state.postData.sharedEntityParams
                                    ).length > 0 ? (
                                    this.state.postData.sharedEntityParams[
                                      "content-not-found"
                                    ] ? (
                                      <ShareContentRemovedPreview />
                                    ) : !this.state.postData.sharedEntityParams[
                                      "max-depth-reached"
                                    ] ? (
                                      this.state.postData.sharedEntityType ===
                                        "EXPLOREBLOG" ? (
                                        <ExploreBlogSharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                        />
                                      ) : this.state.postData.sharedEntityType ===
                                        "ASSIGNMENT" ||
                                        this.state.postData.sharedEntityType ===
                                        "JOB" ||
                                        this.state.postData.sharedEntityType ===
                                        "TRAINING" ||
                                        this.state.postData.sharedEntityType ===
                                        "EXPEDITION" ||
                                        this.state.postData.sharedEntityType ===
                                        "FUNDRAISE" ||
                                        this.state.postData.sharedEntityType ===
                                        "STORYBOOK" ||
                                        this.state.postData.sharedEntityType ===
                                        "EVENT" ? (
                                        <ProjectSharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                        />
                                      ) : (this.state.postData.sharedEntityType === "FORUM" || this.state.postData.sharedEntityParams?.postType === "FORUM") ? (
                                        <ForumSharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                          entityItem={this.state.postData}
                                        />
                                      ) : (this.state.postData.sharedEntityType === "POLL" || this.state.postData.sharedEntityParams?.postType === "POLL") ? (
                                        <PollSharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                          entityItem={this.state.postData}
                                        />
                                      ) : this.state.postData?.sharedEntityType === "POST" && this.state.postData.sharedEntityParams && this.state.postData.sharedEntityParams?.secondaryAttachmentIds && this.state.postData.sharedEntityParams?.secondaryAttachmentIds.length > 0 && this.state.postData.sharedEntityParams.secondaryAttachmentIds[0].attachmentType === "PPT" ? 
                                          (
                                          <PresentationSharePreview 
                                            type={this.state.postData.sharedEntityType}
                                            entityItem={this.state.postData}
                                            item={this.state.postData.sharedEntityParams} 
                                          />
                                        )
                                        : (this.state.postData.sharedEntityType === "POST" && this.state.postData.sharedEntityParams?.postType !== "FORUM" && this.state.postData.sharedEntityParams?.postType !== "POLL") ? (
                                        <PostSharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          entityItem={this.state.postData}
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                        />
                                      ) : this.state.postData.sharedEntityType ===
                                        "STORY" ? (
                                        <StorySharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                        />
                                      ) : this.state.postData.sharedEntityType ===
                                        "STUDIO" ? (
                                        <StudioSharePreview
                                          type={
                                            this.state.postData.sharedEntityType
                                          }
                                          entityItem={this.state.postData}
                                          item={
                                            this.state.postData.sharedEntityParams
                                          }
                                          pageType="DETAILS" /> 
                                        ) : null 
                                    ) : null
                                  ) : null}
                                </div>
                              </>
                            ) : (
                              <div className="hpostconttop">
                                {((this.state.postData &&
                                  this.state.postData.description &&
                                  this.state.postData.description !== "") ||
                                  this.state.postData.hashTags) && (
                                    <ReadMoreReadLess
                                      id={this.state.postData.id}
                                      description={
                                        this.state.postData.description
                                      }
                                      hashTags={this.state.postData.hashTags}
                                    />
                                  )}
                                {this.state.linkdata && (
                                  this.linkDataSection(this.state.linkdata, this.state.og_data2, regexSite)
                                )}
                                {this.state.postData && this.state.postData.secondaryAttachmentIds && this.state.postData.secondaryAttachmentIds.length === 1 && (this.state.postData.secondaryAttachmentIds[0].attachmentType === "PPT" || this.state.postData.secondaryAttachmentIds[0].attachmentType === "PPTX") &&
                                    <PresentationPostView attachments={this.state.postData.secondaryAttachmentIds[0]} />
                                }
                              </div>
                            )}

                            <div className="hpostcontbott">
                                <div className="hpostcontbottLeft">
                                  {(this.state.postData.secondaryAttachmentIds && this.state.postData.secondaryAttachmentIds.length > 0 && this.state.postData.secondaryAttachmentIds[0].attachmentType !== "PPT" && this.state.postData.secondaryAttachmentIds[0].attachmentType !== "PPTX") ? 
                                      <CommonAttachmentSection attachments={this.state.postData.secondaryAttachmentIds} itemId={this.state.postData.id} /> : 
                                      <div className="fattach"/>
                                  }
                                </div>

                                <div className="likesblk">
                                  <a href="javascript:void(0)" onClick={this.handleLogin.bind(this)} className={"like"} />
                                  <a href="javascript:void(0)" onClick={this.handleLogin.bind(this)} >
                                    {this.state.postData && this.state.postData.likesCount}
                                    &nbsp;
                                    <span>
                                      {this.state.postData && this.state.postData.likesCount <= 1
                                        ? "Like"
                                        : "Likes"}
                                    </span>
                                  </a>
                                </div>
                                <a href="javascript:void(0)" className="comments" id="commntIco" onClick={this.handleLogin.bind(this)}>
                                  <span className="art_btn_bx">
                                    {this.state.postData && this.state.postData.commentCount}
                                    &nbsp;
                                    <span>
                                      {this.state.postData && this.state.postData.commentCount <= 1
                                        ? "Comment"
                                        : "Comments"}
                                    </span>
                                  </span>
                                </a>
                            </div>
  
                            <div className="hpostconttop" style={{ margin: "0" }}>
                              {this.state.postData.postLocation && (
                                <span className="address">
                                  <i className="iLocation" />
                                  {this.state.postData.postLocation}
                                </span>
                              )}
                            </div>

                          </div>
  
                          <UnauthPageItem signUpRequired={this.signUpRequired} pathName={`post/${this.props.match.params.id}`} history={this.props.history} />
  
                          <div className="bottomFloatButton">
                            <a
                              href="javascript:void(0)"
                              onClick={this.signUpRequired.bind(this)}
                              className="bkloginBtn"
                            >
                              <span>Join Us</span> to discover your passion for
                              nature
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </main>
              {(this.state.notFoundStatusCode || this.state.postData.activityTabPrivate) && !adminFlagData() ?
                <LeftPanelUnauth signUpRequired={this.signUpRequired} /> : null
              }
              {this.state.loginRequired === true ? (
                <AuthModalComponent
                  handleLoginClose={this.handleLoginClose}
                  pathname={this.state.pathname}
                  history={this.props.history}
                />
              ) : null}
              {this.state.signUpRequired === true ? (
                <SignUpModal
                  handleSignUpClose={this.handleSignUpClose}
                  history={this.props.history}
                />
              ) : null}
            </div>
          </>
        );
      }
    } else {
      var regex = /\s+/gi;
      let Stripbody = stripHtml(this.state.editedText)
        .trim()
        .replace(regex, " ")
        .split(" ").length;
      return (
        <>
          {this.state.redirectToProfile && (
            <Redirect push to={"/profile/" + this.state.redirectToProfile} />
          )}
          {this.state.redirectToCircle && (
            <Redirect push to={"/community/" + this.state.redirectToCircle} />
          )}
          <div className={"wrapper projectpage forumpage allDetailsPage" + (((this.state.notFoundStatusCode || this.state.postData.activityTabPrivate || this.state.postData.hidden) && this.state.postData.userId != this.state.userId) && !this.state.postData.selfHidden ? " staticPage" : "")}>
            {this.state.notFoundStatusCode || this.state.postData.activityTabPrivate ||
              (this.state.postData.hidden &&
                this.state.postData.userId != this.state.userId) ? (
              <Header EditedText={true} />
            ) : (
              <Header />
            )}
            <main className="dgcontainer hm3col">
              <div className="container">
                {this.state.notFoundStatusCode &&
                  this.state.postData.userId != this.state.userId ? (
                  <HideInfoPage deletePost={true} />
                ) : ((this.state.postData.hidden && this.state.postData.userId != this.state.userId && this.state.postData.creatorId != this.state.userId) || this.state.postData.activityTabPrivate) ? (
                  <PrivateProjectHidePage myStudioPage={true} />
                ) : (
                  <div className="row">
                    <LeftPanel />
                    <div className="col-md-9">
                      <div className="projectinn">
                        <div class="mt-3"><button class="goback btn globalback" onClick={() => this.props.history.goBack()}>Back</button></div>
                        <div className="forumdesctop">
                          <div className="forumdesctophead">
                            <div className="fdtheadleft">
                              {this.state.postData.userId &&
                                !this.state.postData.userEntityType ? (
                                <div className="fuserfollow post">
                                  <figure
                                    className="userlogo"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.redirectToProfile(
                                        this.state.postData.userCustomUrl
                                      );
                                    }}
                                  >
                                    <img
                                      src={
                                        this.state.postData.userProfileImage !=
                                          null
                                          ? getCDNUrl(
                                            this.state.postData
                                              .userProfileImage
                                          )
                                          : this.state.postData.userType !==
                                            "COMPANY"
                                            ? "https://cdn.dscovr.com/images/users1.png"
                                            : "https://cdn.dscovr.com/images/DefaultBusiness.png"
                                      }
                                      alt=""
                                    />
                                  </figure>
                                  <div>
                                    <h3
                                      className= {"userName" + (this.state.postData.userType === "COMPANY" ? " orgnzName" : "")}
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "5px",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.redirectToProfile(
                                          this.state.postData.userCustomUrl
                                        );
                                      }}
                                    >
                                      {this.state.postData.userName}
                                    </h3>
                                    {this.state.postData.createdBy}
                                    {this.state.userData &&
                                      this.state.postData &&
                                      this.state.userData.userId &&
                                      this.state.postData.userId &&
                                      this.state.userId !==
                                      this.state.postData.userId && (
                                        <Follow
                                          key={this.state.postData.userId}
                                          followed={
                                            this.state.postData.followed
                                          }
                                          deactivated={
                                            this.state.postData.deactivated
                                          }
                                          userId={this.state.postData.userId}
                                        />
                                      )}
                                    {this.state.postData && this.state.postData.persona &&
                                      <div className="hpostPersona">{this.state.postData.persona}</div>}
                                    <div className="pdUserAddrss hpostdtls">
                                      {this.state.postData &&
                                        this.state.postData.country && (
                                          <span className="address">
                                            <i className="iLocation" />
                                            {this.state.postData &&
                                              this.state.postData.country}
                                          </span>
                                        )}
                                      <span style={{ color: "#333333" }}>
                                        {timeAgo.format(d, "mini-now")}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ) : this.state.postData.userEntityType &&
                                this.state.postData.params ? (
                                <div className="fuserfollow post">
                                  <figure
                                    className="userlogo"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.redirectToCircle(
                                        this.state.postData.params &&
                                        this.state.postData.params[
                                        "circleSlug"
                                        ]
                                      );
                                    }}
                                  >
                                    <img
                                      src={
                                        this.state.postData.params &&
                                          this.state.postData.params[
                                          "circleImage"
                                          ] != null
                                          ? getCDNUrl(
                                            this.state.postData.params &&
                                            this.state.postData.params[
                                            "circleImage"
                                            ]
                                          )
                                          : "https://cdn.dscovr.com/images/circleDefault.webp"
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "https://cdn.dscovr.com/images/circleDefault.png";
                                      }}
                                      alt=""
                                    />
                                  </figure>
                                  <div>
                                    <h3
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "5px",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.redirectToCircle(
                                          this.state.postData.params &&
                                          this.state.postData.params[
                                          "circleSlug"
                                          ]
                                        );
                                      }}
                                    >
                                      {this.state.postData.params &&
                                        this.state.postData.params[
                                        "circleTitle"
                                        ]}
                                    </h3>
                                    {/* <EntityFollow
                                      entityType={"CIRCLE"}
                                      entityId={
                                        this.state.postData.params["circleId"]
                                      }
                                      followed={this.state.postData.followed}
                                      userId={feedbackTabVisiblethis.state.userData.userId}
                                      isCircle={true}
                                    /> */}
                                    {this.state.postData && this.state.postData.persona &&
                                      <div className="hpostPersona">{this.state.postData.persona}</div>}
                                    <div className="pdUserAddrss hpostdtls">
                                      {this.state.postData &&
                                        this.state.postData.country && (
                                          <span className="address">
                                            <i className="iLocation" />
                                            {this.state.postData &&
                                              this.state.postData.country}
                                          </span>
                                        )}
                                      <span style={{ color: "#333333" }}>
                                        {timeAgo.format(d, "mini-now")}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            {/* <div className="fdtheadright">
                              <div className="fdtheadrightbott">
                                <div className="forumrowbright">
                                  {this.state.postData &&
                                    !_.isUndefined(
                                      this.state.postData.likesCount
                                    ) && <UserReactionComponent item={this.state.postData} key={this.state.postData.id} pathType={'postDetails'} />}
                                  <a
                                    href="javascript:void(0)"
                                    className="comments"
                                    id="commntIco"
                                  >
                                    <span>
                                      {this.state.commentCount}&nbsp;
                                      <span>
                                        {this.state.commentCount <= 1
                                          ? "Comment"
                                          : "Comments"}
                                      </span>
                                    </span>
                                  </a>
                                  {this.state.postData &&
                                    this.state.postData.id && (
                                      <Share
                                        shareUrl={"/post/"}
                                        hideShareOnPortalBtn={
                                          this.state.postData.postVisibility !==
                                          "ANYONE"
                                        }
                                        entityId={
                                          this.state.postData.sharedEntityId
                                            ? this.state.postData.sharedEntityId
                                            : this.state.postData.id
                                        }
                                        //entityId={this.state.postData.id}
                                        entityType={
                                          this.state.postData.sharedEntityType
                                            ? this.state.postData
                                              .sharedEntityType
                                            : "POST"
                                        }
                                        shareId={this.state.postData.id}
                                        sharesCount={
                                          this.state.postData.sharesCount
                                        }
                                      //sharesCount={this.state.postData.sharedEntityId ? this.state.postData.sharedEntityParams.sharesCount : this.state.postData.sharesCount}
                                      />
                                    )}                                    
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        
                        <div className="forumdescmain">
                          <div className="toptitleblk">
                            {this.state.successMessage === "Success!" &&
                              this.state.postData &&
                              this.state.postData.sharedEntityType != "JOB" &&
                              !this.state.postData.selfHidden && !this.state.postData.sharedEntityParams[
                                "content-not-found"
                              ] && (
                                <h5>
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.openOriginalPost(
                                        this.state.postData
                                      );
                                    }}
                                    href="javascript:void(0)"
                                    className="viewsource"
                                  >
                                    <i className="iArrow-Up" />
                                    View Source
                                  </a>
                                </h5>
                              )}
                            <div className="contxmenu">
                              <button
                                type="button"
                                className="btn"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                disabled={
                                  this.state.userId ===
                                  this.state.postData.userId &&
                                  this.state.postData.selfHidden
                                }
                              >
                                <i className="iKebab" />
                              </button>
                              <div className="dropdown-menu fadeIn animated">
                                <SavePostButton key={this.state.postData.id} id={this.state.postData.id} bookMarkFlag={this.state.postData.bookMark} entityType={"POST"} /> 
                                {this.state.postData && this.state.postData.canEdit &&
                                  !this.state.postData.selfHidden && (
                                    <>                                    
                                      {!this.state.postData.paidPost && this.state.postData.attachmentIds &&
                                        this.state.postData.attachmentIds.length > 0 && (
                                          this.state.postData.attachmentIds[0].attachmentType === "VIDEO" || this.state.postData.attachmentIds[0].attachmentType === "IMAGE") && <Link className="dropdown-item" to={`/feed/post-studio/${this.state.postData.id}`}><i className="istudio" style={{ fontSize: '13px' }} /> Publish in Studio</Link>}
                                      {this.state.postData && this.state.postData.postType !==
                                        "LINK" && (
                                          <a
                                            className="dropdown-item"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.state.postData.postType !== "ARTICLE" ? this.openEditPost(this.state.postData.id, this.state.postData.description) : this.openEditModal(this.state.postData)
                                            }}
                                            href="javascript:void(0)"
                                          >
                                            <i className="iEditBox" /> Edit Post
                                          </a>
                                        )}
                                      {this.state.postData &&
                                        this.state.postData.postType ===
                                        "LINK" && (
                                          <a
                                            className="dropdown-item"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.openEditLinkPost();
                                            }}
                                            href="javascript:void(0)"
                                          >
                                            <i className="iEditBox" /> Edit Post
                                          </a>
                                        )}
                                      <a
                                        classNfeedbackTabVisibleame="dropdown-item"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.openDeleteModal();
                                        }}
                                        href="javascript:void(0)"
                                      >
                                        <i className="iTrashBin" /> Delete Post
                                      </a>
                                    </>
                                  )}
                                {!this.state.postData.selfHidden && (
                                  <span
                                    className="dropdown-item"
                                    onClick={(e) => {
                                      this.handleHideModal(
                                        this.state.postData.id
                                      );
                                    }}
                                  >
                                    <i
                                      className="iHide"
                                      style={{ fontSize: "13px" }}
                                    />{" "}
                                    Hide
                                  </span>
                                )}
                                {this.state.userData.userId !==
                                  this.state.postData.creatorId &&
                                  this.state.userId !==
                                  this.state.postData.userId &&
                                  this.state.postData.canReport && (
                                    <a
                                      className="dropdown-item"
                                      href="javascript:void(0)"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({
                                          openReportModal:
                                            this.state.postData.id,
                                        });
                                      }}
                                    >
                                      <i className="iReportComment_OL" /> Report
                                    </a>
                                  )}
                              </div>
                              {this.state.openReportModal &&
                                this.state.openReportModal ===
                                this.state.postData.id && (
                                  <ReportAbuse
                                    entityId={this.state.postData.id}
                                    entityType={"POST"}
                                    refreshAllData={this.refreshAllData}
                                    triggerReportClose={this.triggerReportClose}
                                  />
                                )}
                            </div>
                          </div>
                          {this.state.postData.postType === "ARTICLE" ? (
                            <div className="postarticleblock">
                              <div className="postarticleimg">
                                {this.state.postData.attachmentIds &&
                                  this.state.postData.attachmentIds[0] &&
                                  this.state.postData.attachmentIds[0]
                                    .attachmentUrl ? (
                                      <img
                                      src={getCDNUrl(getOptimizedArticleImage(this.state.postData.attachmentIds[0]))}
                                      alt=""
                                    />
                                ) : (
                                  <img
                                    src="https://cdn.dscovr.com/images/banner-explore-blog-small.webp"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "https://cdn.dscovr.com/images/banner-explore-blog-small-new.png";
                                    }}
                                    alt=""
                                  />
                                )}
                              </div>
                              <div className="postarticledesc">
                                {/*<div className="pacategory">Animals</div>*/}
                                <div className="paauthor">
                                  {this.state.postData.userName}
                                </div>
                                <h2 className="articlePostTitle">{this.state.postData.title}</h2>
                                <div
                                  className="padesctxt"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      this.state.postData &&
                                        this.state.postData.description
                                        ? this.state.postData.description
                                          .replace(/&nbsp;/g, " ")
                                          .replace(/(\r\n|\r|\n)/g, "<br>")
                                          .replace(/(\\n)/g, "<br>")
                                        : "",
                                  }}
                                />
                                <div className="text-center">
                                  <a
                                    href="javascript:void(0)"
                                    onClick={() =>
                                      window.open(
                                        "/explore-detail/article/" + this.state.postData.slug,
                                        "_blank",
                                        "toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=50,width=1000,height=1000"
                                      )
                                    }
                                    className="more btn"
                                  >
                                    read more
                                  </a>
                                </div>
                              </div>
                            </div>
                          ) : this.state.postData.attachmentIds &&
                            this.state.postData.attachmentIds.length > 0 ? (
                            this.state.postData.attachmentIds[0]
                              .attachmentType === "VIDEO" ? (
                              <div>
                                <div className="hpostconttop">
                                  {((this.state.postData &&
                                    this.state.postData.description &&
                                    this.state.postData.description !== "") ||
                                    this.state.postData.hashTags) && (
                                      <ReadMoreReadLess
                                        id={this.state.postData.id}
                                        description={
                                          this.state.postData.description
                                        }
                                        hashTags={this.state.postData.hashTags}
                                      />
                                    )}

                                  <figure className="hpostimggrid">
                                    <div className="himggrid vidbox">
                                      <a
                                        data-fancybox={this.state.postData.id}
                                        href={getCDNUrl(
                                          get720pTranscodedVideo(
                                            this.state.postData.attachmentIds[0]
                                          )
                                        )}
                                      >
                                        {((this.state.postData?.thumbnail) || (this.state.postData.attachmentIds[0].thumbnails &&  this.state.postData.attachmentIds[0].thumbnails[0])) ? (
                                          <img
                                            src={getCDNUrl(videoThumbnailFunction(this.state.postData))}
                                            alt=""
                                          />
                                        ) : (
                                          <img
                                            src="https://cdn.dscovr.com/images/video-blank2.webp"
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "https://cdn.dscovr.com/images/video-blank2.png";
                                            }}
                                            alt=""
                                          />
                                        )}
                                        <span className="playbutt"><i className="iPlay" /></span>
                                      </a>
                                    </div>
                                  </figure>
                                </div>
                              </div>
                            ) : this.state.postData.attachmentIds[0]
                              .attachmentType === "AUDIO" ? (
                              <div>
                                <div className="hpostconttop">
                                  {((this.state.postData &&
                                    this.state.postData.description &&
                                    this.state.postData.description !== "") ||
                                    this.state.postData.hashTags) && (
                                      <ReadMoreReadLess
                                        id={this.state.postData.id}
                                        description={
                                          this.state.postData.description
                                        }
                                        hashTags={this.state.postData.hashTags}
                                      />
                                    )}

                                  <AudioPlayer
                                    showJumpControls={false}
                                    customVolumeControls={[]}
                                    customAdditionalControls={[]}
                                    showDownloadProgress={false}
                                    src={getCDNUrl(
                                      this.state.postData.attachmentIds[0]
                                        .attachmentUrl
                                    )}
                                  />
                                </div>
                              </div>
                            ) : (this.state.postData.attachmentIds[0].attachmentType === "PPT" || this.state.postData.attachmentIds[0].attachmentType === "PDF") ? (
                              <div>
                                <div className="hpostconttop">
                                  {((this.state.postData &&
                                    this.state.postData.description &&
                                    this.state.postData.description !== "") ||
                                    this.state.postData.hashTags) && (
                                      <ReadMoreReadLess
                                        id={this.state.postData.id}
                                        description={
                                          this.state.postData.description
                                        }
                                        hashTags={this.state.postData.hashTags}
                                      />
                                    )}
                                    <PresentationPostView attachments={this.state.postData.attachmentIds[0]} documentTitle={this.state.documentTitle} />
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div className="hpostconttop">
                                  {((this.state.postData &&
                                    this.state.postData.description &&
                                    this.state.postData.description !== "") ||
                                    this.state.postData.hashTags) && (
                                      <ReadMoreReadLess
                                        id={this.state.postData.id}
                                        description={
                                          this.state.postData.description
                                        }
                                        hashTags={this.state.postData.hashTags}
                                      />
                                    )}
                                  {this.state.photoListMap &&
                                    this.state.photoListMap.length > 0 && (
                                      <Images
                                        images={this.state.photoListMap}
                                        countFrom={5}
                                        photoListOriginalMap={
                                          this.state.photoListOriginalMap
                                        }
                                      />
                                    )}
                                </div>
                              </div>
                            )
                          ) : this.state.postData.postType === "LINK" ? (
                            this.state.postData.postLinkTypeUrl && !this.state.editLinkPopUpShow &&
                            this.isValidUrl(this.state.postData.postLinkTypeUrl) && (
                              <>
                                <div className="hpostconttop">
                                  {((this.state.postData &&
                                    this.state.postData.description &&
                                    this.state.postData.description !== "") ||
                                    this.state.postData.hashTags) && (
                                      <ReadMoreReadLess
                                        id={this.state.postData.id}
                                        description={
                                          this.state.postData.description
                                        }
                                        hashTags={this.state.postData.hashTags}
                                      />
                                    )}
                                  <div className="linkpostpreview">
                                    <div className="prevtitle">Preview</div>
                                    <div className="postarticledesc">
                                      {this.state.postData.postLinkTypeUrl.indexOf(
                                        "https://youtu.be"
                                      ) !== -1 ||
                                        this.state.postData.postLinkTypeUrl.indexOf(
                                          "www.youtube.com/watch"
                                        ) !== -1 ? (
                                        <>
                                          <div className="vidPlayerOverWrap">
                                            <Waypoint onEnter={() => this.handleEnterViewport()} onLeave={() => this.handleExitViewport()} scrollableAncestor='window'>
                                              <div>
                                                <ReactPlayer
                                                  url={
                                                    this.state.postData
                                                      .postLinkTypeUrl
                                                  }
                                                  width={"100%"}
                                                  playing={this.state.shouldPlay}
                                                  controls={true}
                                                  muted={true}
                                                />
                                              </div>
                                            </Waypoint>
                                            <span className="vidOverlay"></span>
                                          </div>
                                          <div className="customLinkPost" onClick={()=>{ window.open(this.state.postData.postLinkTypeUrl, "_blank")}}>
                                            <div className="customLinkPostDesc">
                                              <h5>{this.state.og_data1?.title}</h5>
                                              <p>{this.state.og_data1?.description}</p>
                                              {/* <p>{this.state.postData.postLinkTypeUrl}</p> */}
                                            </div>
                                          </div>
                                          <a
                                            href={
                                              this.state.postData
                                                .postLinkTypeUrl
                                            }
                                            className="btn playYoutube"
                                            target="_blank"
                                          >
                                            <i className="iYouTube_Logo" /> Play
                                            on Youtube
                                          </a>
                                        </>
                                      ) : (!_.isEmpty(this.state.og_data1) &&  
                                        <CommonLinkPreview linkdata={this.state.postData.postLinkTypeUrl} og_data={this.state.og_data1} />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )
                          ) : this.state.postData.sharedEntityId &&
                            this.state.postData.sharedEntityId !== "" ? (
                            <>
                              <div className="hpostconttop">
                                {((this.state.postData &&
                                  this.state.postData.description &&
                                  this.state.postData.description !== "") ||
                                  this.state.postData.hashTags) && (
                                    <ReadMoreReadLess
                                      id={this.state.postData.id}
                                      description={
                                        this.state.postData.description
                                      }
                                      hashTags={this.state.postData.hashTags}
                                    />
                                  )}
                                {this.state.postData.sharedEntityType ===
                                  "STUDIO" && !this.state.postData.sharedEntityParams[
                                    "content-not-found"
                                  ] && <StudioSharePreview
                                    type={
                                      this.state.postData.sharedEntityType
                                    }
                                    item={
                                      this.state.postData.sharedEntityParams
                                    }
                                    entityItem={this.state.postData}
                                    pageType="DETAILS" />}
                                {this.state.postData.sharedEntityParams &&
                                  Object.keys(
                                    this.state.postData.sharedEntityParams
                                  ).length > 0 ? (
                                  this.state.postData.sharedEntityParams[
                                    "content-not-found"
                                  ] ? (
                                    <ShareContentRemovedPreview />
                                  ) : !this.state.postData.sharedEntityParams[
                                    "max-depth-reached"
                                  ] ? (
                                    this.state.postData.sharedEntityType ===
                                      "EXPLOREBLOG" ? (
                                      <ExploreBlogSharePreview
                                        type={
                                          this.state.postData.sharedEntityType
                                        }
                                        item={
                                          this.state.postData.sharedEntityParams
                                        }
                                      />
                                    ) : this.state.postData.sharedEntityType ===
                                      "ASSIGNMENT" ||
                                      this.state.postData.sharedEntityType ===
                                      "JOB" ||
                                      this.state.postData.sharedEntityType ===
                                      "TRAINING" ||
                                      this.state.postData.sharedEntityType ===
                                      "STORYBOOK" ||
                                      this.state.postData.sharedEntityType ===
                                      "EXPEDITION" ||
                                      this.state.postData.sharedEntityType ===
                                      "FUNDRAISE" ||
                                      this.state.postData.sharedEntityType ===
                                      "EVENT" ? (
                                      <ProjectSharePreview
                                        type={
                                          this.state.postData.sharedEntityType
                                        }
                                        item={
                                          this.state.postData.sharedEntityParams
                                        }
                                      />
                                    ) : (this.state.postData.sharedEntityType === "FORUM" || this.state.postData.sharedEntityParams?.postType === "FORUM") ? (
                                      <ForumSharePreview
                                        type={
                                          this.state.postData.sharedEntityType
                                        }
                                        item={
                                          this.state.postData.sharedEntityParams
                                        }
                                        entityItem={this.state.postData}
                                      />
                                    ) : (this.state.postData.sharedEntityType === "POLL" || this.state.postData.sharedEntityParams?.postType === "POLL") ? (
                                      <PollSharePreview
                                        type={
                                          this.state.postData.sharedEntityType
                                        }
                                        item={
                                          this.state.postData.sharedEntityParams
                                        }
                                        entityItem={this.state.postData}
                                      />
                                    ) : this.state.postData?.sharedEntityType === "POST" && this.state.postData.sharedEntityParams && this.state.postData.sharedEntityParams?.secondaryAttachmentIds && this.state.postData.sharedEntityParams?.secondaryAttachmentIds.length > 0 && this.state.postData.sharedEntityParams.secondaryAttachmentIds[0].attachmentType === "PPT" ? 
                                          (
                                          <PresentationSharePreview 
                                            type={this.state.postData.sharedEntityType}
                                            entityItem={this.state.postData}
                                            item={this.state.postData.sharedEntityParams} 
                                          />
                                        )
                                    : this.state.postData.sharedEntityType === "POST" && this.state.postData.sharedEntityParams?.postType !== "FORUM" && this.state.postData.sharedEntityParams?.postType !== "POLL" ? (
                                      <PostSharePreview
                                        type={
                                          this.state.postData.sharedEntityType
                                        }
                                        entityItem={this.state.postData}
                                        item={
                                          this.state.postData.sharedEntityParams
                                        }
                                      />
                                    ) : this.state.postData.sharedEntityType ===
                                      "STORY" ? (
                                      <StorySharePreview
                                        type={
                                          this.state.postData.sharedEntityType
                                        }
                                        item={
                                          this.state.postData.sharedEntityParams
                                        }
                                      />
                                    ) : null
                                  ) : null
                                ) : null}
                              </div>
                            </>
                          ) : (
                            <div className="hpostconttop">
                              {((this.state.postData &&
                                this.state.postData.description &&
                                this.state.postData.description !== "") ||
                                this.state.postData.hashTags) && (
                                  <ReadMoreReadLess
                                    id={this.state.postData.id}
                                    description={
                                      this.state.postData.description
                                    }
                                    hashTags={this.state.postData.hashTags}
                                  />
                                )}
                              {this.state.linkdata && (
                                this.linkDataSection(this.state.linkdata, this.state.og_data2, regexSite)
                              )}
                            </div>
                          )}
                          <div className={"hpostcontbott" + (this.state.postData?.canEdit && this.state.showStatsFlag ? " pr-5" : "")}>
                            <div className="hpostcontbottLeft">
                            {(this.state.postData.secondaryAttachmentIds && this.state.postData.secondaryAttachmentIds.length > 0 && this.state.postData.secondaryAttachmentIds[0].attachmentType !== "PPT" && this.state.postData.secondaryAttachmentIds[0].attachmentType !== "PPTX") ? 
                                <CommonAttachmentSection attachments={this.state.postData.secondaryAttachmentIds} itemId={this.state.postData.id} /> : 
                                <div className="fattach"/>
                            }
                            </div>

                            {this.state.postData &&
                              !_.isUndefined(
                                this.state.postData.likesCount
                              ) && <UserReactionComponent item={this.state.postData} key={this.state.postData.id} pathType={'postDetails'} />}
                            <a
                              href="javascript:void(0)"
                              className="comments"
                              id="commntIco"
                            >
                              <span className="art_btn_bx">
                                {this.state.commentCount}&nbsp;
                                <span>
                                  {this.state.commentCount <= 1
                                    ? "Comment"
                                    : "Comments"}
                                </span>
                              </span>
                            </a>
                            {this.state.postData &&
                              this.state.postData.id && (
                                <Share
                                  shareUrl={"/post/"}
                                  hideShareOnPortalBtn={
                                    this.state.postData.postVisibility !==
                                    "ANYONE"
                                  }
                                  entityId={
                                    this.state.postData.sharedEntityId
                                      ? this.state.postData.sharedEntityId
                                      : this.state.postData.id
                                  }
                                  //entityId={this.state.postData.id}
                                  entityType={
                                    this.state.postData.sharedEntityType
                                      ? this.state.postData
                                        .sharedEntityType
                                      : "POST"
                                  }
                                  shareId={this.state.postData.id}
                                  sharesCount={
                                    this.state.postData.sharesCount
                                  }
                                //sharesCount={this.state.postData.sharedEntityId ? this.state.postData.sharedEntityParams.sharesCount : this.state.postData.sharesCount}
                                />
                              )}
                            {(this.state.postData?.canEdit || this.state.postData?.featuredPostAccess) && !this.state.postData?.sharedEntityParams['content-not-found'] && this.state.showStatsFlag && 
                              <a href="javascript:void(0)" className="postVStats" data-toggle="collapse" />
                            }
                          </div>
                          

                          {/* {this.state.hashTags && (
                            <div className="frdtagslist">
                              {this.state.hashTags.map((item) => {
                                return (
                                  <span key={item}>
                                    <a href={"/explore-hashtag/" + item}>
                                      {item}
                                    </a>
                                  </span>
                                );
                              })}
                            </div>
                          )} */}
                          {this.state.postData.postLocation && (
                            <div className="hpostconttop" style={{ margin: "0" }}>                            
                                <span className="address">
                                  <i className="iLocation" />
                                  {this.state.postData.postLocation}
                                </span>                            
                            </div>
                          )}

                          {(this.state.postData?.canEdit || this.state.postData?.featuredPostAccess) && !this.state.postData?.sharedEntityParams['content-not-found'] && this.state.commentSuccessMessage === "Success!" &&
                            <div className="fadeIn animated potViewGlobal collapse">
                              <CommonPostViews entityId={this.state.postData?.id} details={true} shareCount={this.state.postData?.sharesCount} interactionsCount={parseInt(this.state.commentCount)+this.state.postData?.likesCount+this.state.postData?.sharesCount} entityType={"POST"} showStatsFunction={this.showStatsFunction} />
                            </div>
                          }
                        </div>
                        <div className="forumdescbott">
                          <div className="row">
                            <div className="col-lg-12">
                              <div style={{ position: "relative" }}>
                                <AddCommentBox item={this.state.postData} getAllComments={this.getAllComments} pageType={"POST_DETAILS"} />
                                {this.state.comments &&
                                  this.state.comments.content &&
                                  this.state.comments.content.length > 0 && (
                                    <div className="forumcommtvlistwrap">
                                      {this.state.comments.content.map(
                                        (comment) => {
                                          return (
                                            <Comment
                                              item={comment}
                                              key={comment.id}
                                              callback={this.getAllComments}
                                              refresh={this.refresh_comment}
                                            />
                                          );
                                        }
                                      )}
                                    </div>
                                  )}
                                {!this.state.pagination &&
                                  this.state.commentCount > 0 && (
                                    <div
                                      className="text-center"
                                      style={{ padding: "15px" }}
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={(e) =>
                                          this.fetchMoreCommentData()
                                        }
                                        className="btn cLoadmore"
                                      >
                                        LoadMore
                                      </a>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </main>
            {(this.state.notFoundStatusCode || this.state.postData.activityTabPrivate || this.state.postData.hidden) && this.state.postData.userId != this.state.userId && !this.state.postData.selfHidden &&
              <LeftPanel />
            }
          </div>
          <div
            className="modal fade dgpopup confirmpop"
            id={this.state.postData.id + "confirmpopForDeletePost"}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                {/* <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Delete Post Confirmation</h5>                                
                                </div> */}
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="confirm-popup-modal-body">
                  Are you sure you want to delete this post?
                </div>
                <div className="modal-footer confirm-popup-modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={this.state.processingDeleteRequest}
                    onClick={() => this.deletePost()}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
          {this.state.editArticleFlag && <EditArticlePopUp item={this.state.articleData} closeEditModal={this.closeEditModal} />}
          <div
            id={this.state.postData.id + "toppostwrap"}
            className="modal fade dgpopup openPostbox"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  {
                    <section className="toppostwrap">
                      <div className="toppostinn">
                        <div className="topposthead"></div>
                        <div className="toppostpopbody">
                          <div className="toppostpoptop">
                            <div className="tpbfieldlogo">
                              <img
                                src="https://cdn.dscovr.com/images/quotes-logo.webp"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://cdn.dscovr.com/images/quotes-logo.png";
                                }}
                                alt=""
                              />
                            </div>
                            <div className="tpbfield">
                              <form action="">
                                <MentionTextArea
                                  value={this.state.editedText}
                                  onChange={this.handlePostTextUpdate}
                                  placeholder="Write here..."
                                  style={{
                                    backgroundColor: "#ff0000",
                                  }}
                                ></MentionTextArea>
                                {(this.state.attachmentType === "PPT" || this.state.attachmentType === "PDF") && 
                                  <div className="presentation-title">
                                      <label>Add Document title <sup className="required-field">*</sup></label>
                                      <input type="text" class="form-control custom-input" placeholder="Add document title here..." name="documentTitle" value={this.state.documentTitle} onChange={this.onHandleChange} />
                                      <span className="login-feedback-error mt-1" style={{ display: "block" }}>{this.state.errors && this.state.errors["documentTitle"]}</span>
                                  </div>
                                }
                                {this.state.smileDisplay && (
                                  <Picker
                                    pickerStyle={{
                                      width: "100%",
                                      height: "200px",
                                    }}
                                    onEmojiClick={this.onEmojiClick}
                                  />
                                )}
                                <span
                                  className="login-feedback-error mt-1"
                                  style={{ display: "block" }}
                                >
                                  {this.state.errors &&
                                    this.state.errors.postText}
                                </span>
                                <div className="toppostpopbott">
                                  <div className="tagfield">
                                    <AutoSuggest
                                      hashTags={this.state.tags}
                                      onDelete={this.onDelete}
                                      onAddition={this.onAddition}
                                      handleTagsChange={this.handleTagsChange}
                                    />
                                    {/*<TagsInput value={this.state.tags}
                                                                                   inputProps={{
                                                                                       id: 'colon',
                                                                                       placeholder: 'Add Hashtags'
                                                                                   }}
                                                                                   onChange={this.handleTagsChange}
                                                                                   addKeys={[9, 13, 32, 62, 188]}
                                                                        />*/}
                                    {/* <span className="khastginfo">Press enter after each # tag</span> */}
                                  </div>
                                  <div className="toppostpopfeatures">
                                    <a
                                      href="javascript:void(0)"
                                      className="attchbtn"
                                      onClick={this.handleSmileDisplay}
                                    >
                                      <i className="iEmoji" />
                                    </a>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="bottpostpopbody">
                          <div className="bottpostpopright">
                            {Stripbody > 400 ? (
                              <></>
                            ) : (
                              <div className="charechterinfo">
                                {400 - Stripbody}{" "}
                                {400 - Stripbody <= 1 ? "word " : "words "}
                                left
                              </div>
                            )}
                            <a
                              href="javascript:void(0)"
                              className="btn cancel"
                              onClick={this.hideUpdateModal}
                            >
                              Cancel
                            </a>
                            <input
                              type="submit"
                              onClick={this.handlePostUpdate}
                              className="btn"
                              value={
                                this.state.isPostUpdating
                                  ? "Loading..."
                                  : "UPDATE"
                              }
                              disabled={this.state.isPostUpdating}
                            />
                          </div>
                        </div>
                      </div>
                    </section>
                  }
                </div>
              </div>
            </div>
          </div>
          {this.state.editLinkPopUpShow && 
            <div id={this.state.postData.id + "toppostwrapLink"} className="modal fade dgpopup openPostbox" data-backdrop="static" data-keyboard="false">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    {
                      <section className="linkpostwrap">
                        <div className="toppostinn">
                          <div className="topposthead">
                            <i className="ilinkico">
                              <img
                                src="https://cdn.dscovr.com/images/link-post-ico.webp"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://cdn.dscovr.com/images/link-post-ico.png";
                                }}
                                alt=""
                              />
                            </i>
                          </div>
                          <div className="blogpostbody">
                            <div className="linkpostcontwrap">
                              <form action="">
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control linkfield"
                                    value={this.state.editedUrl}
                                    onChange={this.handleUrlUpdate}
                                    placeholder="type or paste your URL here..."
                                  />
                                </div>
                                <MentionTextArea
                                  value={this.state.editedText}
                                  onChange={this.handlePostTextUpdate}
                                  placeholder="Add Comment"
                                ></MentionTextArea>
                                <span
                                  className="login-feedback-error mt-1"
                                  style={{ display: "block" }}
                                >
                                  {this.state.errors && this.state.errors.postText}
                                </span>
                                <div className="toppostpopbott">
                                  <div className="tagfield">
                                    <AutoSuggest
                                      hashTags={this.state.tags}
                                      onDelete={this.onDelete}
                                      onAddition={this.onAddition}
                                      handleTagsChange={this.handleTagsChange}
                                    />
                                  </div>
                                </div>
                                <div className="linkpostpreview">
                                  <div className="prevtitle">Preview</div>
                                  <div className="postarticledesc">
                                    {(!_.isEmpty(this.state.og_data3) &&  
                                        <CommonLinkPreview linkdata={this.state.validUrlLinkPreview} og_data={this.state.og_data3} />
                                    )}
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="bottpostpopbody">
                            <div className="bottpostpopright">
                              {Stripbody > 400 ? (
                                <></>
                              ) : (
                                <div className="charechterinfo">
                                  {400 - Stripbody}{" "}
                                  {400 - Stripbody <= 1 ? "word " : "words "}
                                  left
                                </div>
                              )}
                              <a
                                href="javascript:void(0)"
                                className="btn cancel"
                                onClick={this.hideUpdateModal}
                              >
                                Cancel
                              </a>
                              <input
                                type="submit"
                                onClick={this.handlePostUpdate}
                                className="btn"
                                value={
                                  this.state.isPostUpdating
                                    ? "Loading..."
                                    : "UPDATE"
                                }
                                disabled={this.state.canNotUpdate}
                              />
                            </div>
                          </div>
                        </div>
                      </section>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          <div
            className="modal fade dgpopup confirmpop"
            id={"AcceptAudio"}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="confirm-popup-modal-body">
                  Your post is updated Successfully
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

export default withRouter(PostDetail);
